module.exports = __webpack_public_path__ + "static/media/spirit_delivery.43255c18.jpeg";